import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { horarioGet, usuarioLugarHorarioIns } from "services/services-mia/miakey";
import { Grid } from "@mui/material";

export default function CambiarEstadoModal({
    selectedRow,
    targetStatus,
    usuarioId,
    merchantServicioUsuarioId,
    updateList,
    closeModal,
}) {
    const [inRequest, setInRequest] = useState(false);
    const [horarios, setHorarios] = useState([]);

    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const formikRef = useRef();
    const isAlta = targetStatus === "A";

    useEffect(() => {
        if (!isAlta) return;
        const fetchHorarios = async () => {
            const { result } = await horarioGet({}, credentials);
            setHorarios(result);
            if (result[0]?.gateHorarioId && formikRef.current) {
                formikRef.current.setFieldValue("horario", result[0].gateHorarioId);
            }
        };
        fetchHorarios();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAlta]);

    const handleSubmit = async ({ horario }) => {
        setInRequest(true);

        const response = await usuarioLugarHorarioIns({
            usuarioId,
            merchantServicioUsuarioId,
            gateZonaId: selectedRow.gateZonaId,
            gateLugarId: selectedRow.gateLugarId,
            gateHorarioId: isAlta ? Number(horario) : selectedRow.gateHorarioId,
            gateUsuarioLugarHorarioStatus: targetStatus,
            gateUsuarioLugarHorarioFH: new Date().toISOString().substring(0, 10),
        }, credentials);

        handleResponse(
            response,
            isAlta ? "Acceso dado de alta exitosamente" : "Acceso dado de baja exitosamente",
            { setSnackbarInfo, setIsOpen: closeModal, setSelected, updateList }
        );

        setInRequest(false);
    };

    return (
        <Formik
            key={`${selectedRow?.gateUsuarioLugarHorarioId ?? selectedRow?.id}-${targetStatus}`}
            innerRef={formikRef}
            initialValues={{
                horario: "",
                zona: selectedRow?.gateZonaNombre ?? "",
                acceso: selectedRow?.gateLugarNombre ?? "",
                horarioNombre: !isAlta ? (selectedRow?.gateHorarioNombre ?? "") : "",
            }}
            validationSchema={yup.object({
                ...(isAlta ? { horario: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required) } : {}),
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <Grid container justifyContent={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <p>{ isAlta ? "¿En que horario desea dar de alta el siguiente acceso?" : "¿Desea dar de baja el siguiente acceso?" }</p>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormikTextInput name="zona" labelText="Zona" disabled fullWidth />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormikTextInput name="acceso" labelText="Acceso" disabled fullWidth />
                    </Grid>
                    {isAlta && (
                        <Grid item xs={12}>
                            <FormikSelectInput name="horario" labelText="Horario">
                                {horarios.map((h) => (
                                    <option key={h.gateHorarioId} value={h.gateHorarioId}>
                                        {h.gateHorarioNombre}
                                    </option>
                                ))}
                            </FormikSelectInput>
                        </Grid>
                    )}
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: isAlta ? "Dar de Alta" : "Dar de Baja" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <CircularIndeterminate />}
                </Grid>
            </Form>
        </Formik>
    );
}
